
let extendContextMenuItems = [];
const validateEmail = (email) => {

    let result = false;

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {

        result = true;
    }

    return result;
}
var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

const sleep = (milliseconds) => new Promise(resolve => setTimeout(resolve, milliseconds));

const toPascalCase = (string) =>
    `${string}`.replace(new RegExp(/[-_]+/, 'g'), ' ').
        replace(new RegExp(/[^\w\s]/, 'g'), '').
        replace(
            new RegExp(/\s+(.)(\w+)/, 'g'),
            ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
        ).
        replace(new RegExp(/\s/, 'g'), '').
        replace(new RegExp(/\w/), s => s.toUpperCase());

const maxWindow = () => {
    const elem = document.body;
    if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
        if (elem.requestFullScreen) {
            elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

const copyGeometry = (mapTool, toast) => {
    var interaction = mapTool.getInteraction("selectTranslate");

    if (interaction && interaction.getFeatures().getArray().length > 0) {


        let newFeature = interaction.getFeatures().getArray()[0].clone();

        mapTool.findLayer('workspace-layer').getSource().addFeature(newFeature);;

        toast.current.show({ severity: 'success', summary: 'Bilgi', detail: 'Obje kopyalandı.' });
    }
    else {
        toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Geometri seçilmedi.' });
        toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Seç / Çizim Taşı Butonundan Çizim Seçiniz.' });
        return;

    }
}

const defaultZoom = (map, maxZoom) => {

    map.getView().on('change:resolution', function () {
        var zoom = map.getView().getZoom();
        if (zoom > maxZoom) {
            map.getView().setZoom(maxZoom);
        }
    });
}

const positionContextMenuResponsive = (menuElement, clientX, clientY)=> {
    const menuWidth = menuElement.offsetWidth;
    const menuHeight = menuElement.offsetHeight;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let x, y;

    if (windowWidth <= 768) {

        x = (windowWidth - menuWidth) / 2;
        y = (windowHeight - menuHeight) / 2;
    } else {

        x = clientX;
        y = clientY;

        if ((x + menuWidth) > windowWidth) x = windowWidth - menuWidth - 10;
        if ((y + menuHeight) > windowHeight) y = windowHeight - menuHeight - 10;
    }

    menuElement.style.left = `${x}px`;
    menuElement.style.top = `${y}px`;
    menuElement.style.zIndex = 9999999999+" !important";
}


const addContextMenu = (contextMenu, items, map) => {
    for (var i = 0; i < contextMenu.items; i++) {

        removeContextMenuItem(contextMenu, contextMenu.items[i].text);
    }
    for (var i = 0; i < items; i++) {

        removeContextMenuItem(contextMenu, items[i].text);
    }
    for (var i = 0; i < contextMenu.getDefaultItems().length; i++) {

        removeContextMenuItem(contextMenu, contextMenu.getDefaultItems()[i].text);
    }
    extendContextMenuItems = [...new Set([...contextMenu.getDefaultItems(), ...contextMenu.items, ...extendContextMenuItems])];
    for (var i = 0; i < items.length; i++) {
        if (extendContextMenuItems.find(x => x == items[i] != null)) {
            if (!items[i]["permission_name"] || (items[i]["permission_name"] && window.Object.checkPermissions([items[i]["permission_name"]]))) {

                extendContextMenuItems.push(items[i]);
            }
        }
    }
    contextMenu.clear();
    contextMenu.extend(extendContextMenuItems);
    if (!map)
        return;

    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    var fnc = function (event) {
        event.preventDefault(); // Varsayılan menüyü kapat
        var a = document.querySelector(".ol-ctx-menu-container");
        const menu = contextMenu.element;
        if (event.originalEvent.clientX <= 1) {
            a.style.display = 'none';
            return;
        }
        a.style.display = 'block';
        setTimeout(() => {
            var height = a.offsetHeight;

         

            let posX = event.originalEvent.clientX;
            let posY = event.originalEvent.clientY;

            a.style.left = `${event.originalEvent.clientX}px`;

            if (posY <= height) {
               
                a.style.top = `${(event.originalEvent.clientY)}px`;

            }
            else {
                a.style.top = `${(event.originalEvent.clientY - height)}px`;


            }



        }, 10);

    }
    map.un('contextmenu', fnc)
    map.on('contextmenu', fnc);

    let touchTimeout = null;

    map.getViewport().addEventListener('touchstart', function (e) {
        touchTimeout = setTimeout(() => {
            const touch = e.touches[0];

            if (!contextMenu) {
                console.warn("Context menu elementi DOM'da bulunamadı!");
                return;
            }

            positionContextMenuResponsive(contextMenu.element, touch.clientX, touch.clientY);
            contextMenu.element.style.display = 'block';
            contextMenu.element.style.zIndex = 55555;;
        }, 600);
    });

    map.getViewport().addEventListener('touchend', function () {
        clearTimeout(touchTimeout);
    });

}


const removeContextMenuItem = (contextMenu, itemText, map) => {

    var itemIndex = extendContextMenuItems.findIndex(item => item.text === itemText);
    if (itemIndex !== -1) {

        extendContextMenuItems.splice(itemIndex, 1); // Diziden kaldırın
    }
    contextMenu.clear();
    contextMenu.extend(extendContextMenuItems);

    if (!map)
        return;
    var fnc = function (event) {
        event.preventDefault(); // Varsayılan menüyü kapat
        //const menu = contextMenu.element;
        //var a = document.querySelector(".ol-ctx-menu-container");
        //a.style.display = 'block';
        //setTimeout(() => {
        //    var height = (extendContextMenuItems.length * 25);

        //    a.style.left = `${event.originalEvent.clientX}px`;
        //    a.style.top = `${event.originalEvent.clientY + 80}px`;

        //    if ((event.originalEvent.clientY + height) >= map.getSize()[1]) {
        //        a.style.left = `${event.originalEvent.clientX}px`;
        //        a.style.top = `${((event.originalEvent.clientY - height))}px`;
        //    }

        //    else if ((event.originalEvent.clientY - height) <= 0) {
        //        a.style.left = `${event.originalEvent.clientX}px`;

        //        a.style.top = `${(event.originalEvent.clientY)}px`;

        //    }


        //}, 5);
    }
    map.un('contextmenu', fnc)
    map.on('contextmenu', fnc);


}



const getCardColor = (kind) => {
    switch (kind) {
        case "book":
            return "green";
        case "game":
            return "red";
        case "movie":
            return "blue";
        default:
            break;
    }
}

const getOverlayByName = (name, mapTool) => {
    var overlays = mapTool.getMap().getOverlays().getArray();

    var selectedOverlay = overlays.find(function (overlay) {
        return overlay.options.id === name;
    });

    return selectedOverlay;

};
//Featureye verilen özelliğe göre propertieslerini popupda göstermek için eklenmiştir
const addPopup = (mapTool, popup_info_key, layerName, popupId) => {

    let overlay = getOverlayByName(popupId, mapTool);

    if (!overlay) {

        overlay = mapTool.addOverlayCustom(popupId, popupId);
    }

    overlay.setPosition(undefined);

    mapTool.getMap().on('singleclick', (evt) => {
        overlay.setPosition(undefined);
        const coordinate = evt.coordinate;
        const feature = mapTool.getMap().forEachFeatureAtPixel(evt.pixel,
            function (feature) {
                if (feature.get("layerName") && feature.get("layerName") === layerName)
                    return feature;
            });
        if (feature && feature.get(popup_info_key)) {
            const container = document.getElementById(popupId);
            const content = document.getElementById(popupId + '-content');
            content.innerHTML = "";
            const closer = document.getElementById(popupId + '-popup-closer');
            var object = feature.get(popup_info_key);

            var columns = Object.entries(object).filter(x => x[0].indexOf("wkt") <= -1 && x[0].indexOf("geoloc") <= -1).map(x => ({ name: x[0], value: x[1] }));

            let html = "";
            html += '<table class="info-table" border="1" style="border-collapse: collapse; width: 400px;">';
            html += '<tbody>';
            console.log(columns);
            for (const element of columns) {
                var key = element.name;
          
                if (key.indexOf("geoloc") <= -1) {
                    let value = object[key];
                    html += '<tr><td>' + element.displayName === null ? key : element.displayName + '</td><td>' + value + '</td></tr>';
                }
            }

            content.innerHTML = html;
            overlay.setPosition(coordinate);
            return;
        }
    });
}

export const otherTool = {
    validateEmail,
    sleep,
    toPascalCase,
    maxWindow,
    getCardColor,
    groupBy,
    copyGeometry,
    addContextMenu,
    removeContextMenuItem,
    defaultZoom,
    addPopup
}

export default otherTool;